module.exports = __webpack_public_path__ + "img/IMG003.ff552ee6.png";